import React from 'react';
import './ChatDrawer.css';

const ChatDrawer = ({ children = undefined, className = '' }) => (
  <div className={`chat-drawer ${className}`}>
        {children}
  </div>
);

export default ChatDrawer;


// WEBPACK FOOTER //
// ./src/components/ChatDrawer.js